﻿import { mutations } from "@/graphql";
import { useContext, useState } from "react";
import { useMutation } from "@apollo/client/react";
import { useSnackbar } from "notistack";
import { useTextDomainContext } from "../../app/providers";

export const useAddUserToPartner = (
  onCompleted: (data?: any) => void = () => {},
  onError: (error?: any) => void = () => {},
) => {
  const { enqueueSnackbar } = useSnackbar();
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const [success, setSuccess] = useState(false);
  const [resetForm, setResetForm] = useState(false);

  const [addUserToPartner, { loading, data }] = useMutation<any>(
    mutations.addUserToPartner,
    {
      onCompleted: (response) => {
        if (response?.addUserToPartner?.success) {
          enqueueSnackbar(gettext("The user has been linked."), {
            variant: "success",
          });
          setResetForm(true);
        } else {
          // enqueueSnackbar(gettext("The user already linked."), {
          enqueueSnackbar(response?.addUserToPartner?.message, {
            variant: "error",
          });
        }
        setSuccess(response?.addUserToPartner?.success);
        // setTimeout(() => {
        //   setSuccess(false);
        //   setResetForm(false);
        // }, 5000);
        onCompleted();
      },
      onError: ({ message }) => {
        setSuccess(false);
        onError(message);
        enqueueSnackbar(message, {
          variant: "error",
        });
      },
      refetchQueries: ["PartnersUsersList", "GetPartners"],
    },
  );

  return {
    addUserToPartner,
    loading,
    success,
    data,
    resetForm,
  };
};
